import { mapActions, mapGetters, mapState } from 'vuex';

export default {
    computed: {
        ...mapGetters('tracking', ['consentKey', 'shouldAskConsent']),
        ...mapState('tracking', ['consent']),
    },
    methods: {
        ...mapActions('tracking', ['updateTrackingConsent', 'updateTrackingUTM', 'acceptTracking', 'refuseTracking']),
        ...mapActions('tracking/teester', ['trackEvent']),
    },
};
